import { authApi } from './api'

export interface AdminUser {
  id: string
  email: string
  name: string | null
  tier: string
}

export async function fetchCurrentUser(): Promise<AdminUser> {
  const res = await authApi.get<{ user: AdminUser }>('/api/v1/auth/me')
  return res.user
}
